<template>
  <div class="animated fadeIn report main-div">
    <vLoading v-if="vLoading" />
    <div class="pe-6 ps-6 py-10">
      <v-row dir="ltr" class="pb-2">
        <v-col class="text-sm-left text-center">
          <v-btn
            to="/admin/advancedReport"
            class="bc-primary text-white no-underline"
            elevation="0"
            width="230"
            ><span class="c-light">بازگشت به صفحه اصلی</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center fs-xlarge c-dark pt-sm-0 pt-6"
          ><span>گزارش طرح‌های کلان دانشگاه‌ها</span></v-col
        >
      </v-row>
      <hr class="my-4" />
      <div class="d-lg-block d-none">
        <v-stepper v-model="stepNumber" alt-labels>
          <v-stepper-header>
            <v-stepper-step
              :complete="stepNumber > 1"
              :active-icon="'mdi-pen'"
              step="1"
            >
              <div @click="stepNumber = 1" class="text-center pointer">
                <p class="fs-xsmall mb-3">گام اول</p>
                <p class="mb-0">انتخاب استان</p>
                <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
                  (
                  <span v-if="selectedStates.length">
                    {{ selectedStates.length + " استان" }}
                  </span>
                  )
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 1 ? 'completed' : ''"></v-divider>

            <v-stepper-step :complete="stepNumber > 2" step="2">
              <div
                @click="
                  stepNumber > 1 && selectedStates.length
                    ? (stepNumber = 2)
                    : ''
                "
                :class="
                  stepNumber > 1 && selectedStates.length ? 'pointer' : ''
                "
                class="text-center"
              >
                <p class="fs-xsmall mb-3">گام دوم</p>
                <p class="mb-0">انتخاب دانشگاه</p>
                <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
                  (
                  <span v-if="selectedUniversity.length">
                    {{ selectedUniversity.length + " دانشگاه" }}
                  </span>
                  )
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 2 ? 'completed' : ''"></v-divider>

            <v-stepper-step step="3">
              <div class="text-center">
                <p class="fs-xsmall mb-3">گام سوم</p>
                <p class="mb-0">مشاهده و خروجی</p>
              </div>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>
      <div class="d-lg-none d-sm-block d-none pt-4">
        <div class="d-flex flex-row justify-content-center c-grey">
          <div
            class="text-center pointer"
            @click="stepNumber = 1"
            :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
          >
            <span>انتخاب استان</span>
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedStates.length">
                {{ selectedStates.length + " استان" }}
              </span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedStates.length ? (stepNumber = 2) : ''
            "
            :class="stepNumber > 1 && selectedStates.length ? 'pointer' : ''"
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب دانشگاه</span
            >
            <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedUniversity.length">
                {{ selectedUniversity.length + " دانشگاه" }}
              </span>
              )
            </div>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none text-center py-4">
        <div class="d-flex flex-column justify-content-center c-grey">
          <div class="text-center" @click="stepNumber = 1">
            <span :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              >انتخاب استان</span
            >
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedStates.length">
                {{ selectedStates.length + " استان" }}
              </span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedStates.length ? (stepNumber = 2) : ''
            "
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب دانشگاه</span
            >
            <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedUniversity.length">
                {{ selectedUniversity.length + " دانشگاه" }}
              </span>
              )
            </div>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <!-- Step 1 -->
      <div v-if="stepNumber == 1">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >استان مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="6" cols="12">
              <v-text-field
                rounded
                filled
                clearable
                class="search-box mt-2 mt-sm-0"
                placeholder="نام استان را جستجو کنید..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <div v-if="!this.filter" class="mt-1 mb-5">
            <v-btn
              @click="!total ? selectAll('state') : removeAll('state')"
              elevation="0"
              class="all-btn"
              >{{ !total ? "همه" : "هیچ" }}</v-btn
            >
          </div>

          <div v-if="!computedStates.length" class="text-center c-grey">
            <hr />
            موردی یافت نشد.
            <hr />
          </div>

          <v-row>
            <v-col
              lg="3"
              md="3"
              sm="4"
              cols="12"
              v-for="(item, index) in computedStates"
              :key="index"
            >
              <div
                class="item-box"
                @click="chooseState(item)"
                :class="
                  selectedStates.includes(item.name) ? 'selected-box' : ''
                "
              >
                {{ item.name }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="stepNumber == 2">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <div class="d-sm-inline-block d-none py-4">
            <span class="pt-4 pe-6 c-grey">استان‌ها:</span>
            <div
              v-for="(item, index) in selectedStates"
              :key="index"
              class="selectedState-box"
            >
              {{ item }}
              <span @click="clearItem(index)" class="pointer">
                <v-icon class="red--text pt-3 ps-3 pe-0">mdi-close</v-icon>
              </span>
            </div>
          </div>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >دانشگاه مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="4" cols="12">
              <v-text-field
                rounded
                filled
                append-icon="mdi-close"
                @click:append="filter = ''"
                class="search-box mt-2 mt-sm-0"
                placeholder="نام دانشگاه را جستجو کنید..."
                v-model="filter"
                @input="goFirst()"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <div
            v-if="!this.filter && computedUniversities.length"
            class="mt-1 mb-5"
          >
            <v-btn
              @click="!total2 ? selectAll('uni') : removeAll('uni')"
              elevation="0"
              class="all-btn"
              >{{ !total2 ? "همه" : "هیچ" }}</v-btn
            >
          </div>

          <div class="universities-page">
            <div v-if="!computedUniversities.length" class="text-center c-grey">
              <hr />
              موردی یافت نشد.
              <hr />
            </div>
            <v-row>
              <v-col
                lg="3"
                md="3"
                sm="4"
                cols="12"
                v-for="(item, index) in computedUniversities"
                :key="index"
              >
                <div
                  @click="chooseUniversity(item)"
                  class="item-box d-flex flex-column py-4"
                  :class="
                    selectedUniversity.includes(item.id) ? 'selected-box' : ''
                  "
                >
                  <div
                    class="check-box"
                    :class="
                      selectedUniversity.includes(item.id) ? 'b-primary' : ''
                    "
                  >
                    <v-icon
                      v-if="selectedUniversity.includes(item.id)"
                      class="c-primary"
                      >mdi-circle</v-icon
                    >
                  </div>

                  <img
                    class="uni-logo"
                    :src="item.url ? item.url : '/uniLogo.png'"
                    alt=""
                  />
                  <span class="text-center pt-3">{{ item.name }}</span>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="universitiesTotalRows" class="mt-6">
            <v-col>
              <v-pagination
                v-model="universitiesCurrentPage"
                :length="
                  Math.ceil(
                    university.filter((x) => x.name.includes(filter)).length /
                      universitiesPerPage
                  )
                "
                :total-visible="5"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                class="float-end"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 3 -->
      <div v-if="stepNumber == 3" class="pb-6">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col
              v-if="selectedUniversity.length"
              class="pt-6 text-sm-right text-center"
            >
              <v-btn @click="selectedUniDialog = true" class="secondary-btn">
                <span class="fs-medium">
                  {{ selectedUniversity.length }} دانشگاه</span
                >
              </v-btn>
            </v-col>
            <v-spacer class="d-none d-sm-block"></v-spacer>
          </v-row>
          <v-row>
            <v-col>
              <div class="main-table">
                <v-row>
                  <v-col md="6" cols="12">
                    <h5 class="mt-6 fs-xlarge text-sm-right text-center pt-3">
                      گزارش موضوعات و طرح‌های کلان دانشگاه‌ها
                    </h5>
                  </v-col>
                  <v-col md="6" cols="12">
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius my-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table3.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل
                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table3"
                        :data="items1Excel"
                        :columns="excelFields"
                        :filename="'جدول-دانشگاه'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                  </v-col>
                </v-row>

                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                  :items="items1"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :busy="tableBusy"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(cats)="data">
                    <ul v-if="data.item.cats && data.item.cats.length">
                      <li v-for="(item, i) in data.item.cats" :key="i">
                        {{ i + 1 }}. {{ item }}
                      </li>
                    </ul>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:cell(uniRequests)="data">
                    <ul
                      v-if="
                        data.item.uniRequests && data.item.uniRequests.length
                      "
                    >
                      <li v-for="(req, i) in data.item.uniRequests" :key="i">
                        {{ i + 1 }}. {{ req.faSubject }} ( {{ req.status }})
                      </li>
                    </ul>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + perPage * (currentPage - 1) + 1 }}
                    </div>
                  </template>
                </b-table>
                <v-row v-if="totalRows">
                  <v-col>
                    <v-pagination
                      v-model="currentPage"
                      :length="Math.ceil(totalRows / perPage)"
                      :total-visible="5"
                      prev-icon="arrow_back"
                      next-icon="arrow_forward"
                      class="float-left"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-dialog v-model="selectedUniDialog" width="600">
            <v-card class="modal-card">
              <v-container class="pa-5">
                <v-row class="mb-1">
                  <v-col class="text-right">
                    <span class="fs-large c-dark pt-1"
                      >دانشگاه‌های انتخاب شده:</span
                    >
                  </v-col>
                  <v-col class="text-left">
                    <span @click="selectedUniDialog = false">
                      <v-icon class="pointer">$Close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div style="max-height: 400px; overflow-y: auto">
                  <div
                    v-for="(item, index) in selectedUniversity"
                    :key="index"
                    class="my-4 fs-medium c-grey d-flex flex-row"
                  >
                    <div class="small-logoBox">
                      <img
                        :src="getLogo(item) ? getLogo(item) : '/uniLogo.png'"
                        alt=""
                      />
                    </div>
                    <div class="pa-4">
                      {{ university.filter((x) => x.id == item)[0].name }}
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <v-row v-if="!pageLoading" class="mt-8 w-100">
        <v-col
          class="text-right pe-0 ps-0"
          v-if="stepNumber < 3"
          md="4"
          sm="6"
          cols="12"
        >
          <v-btn
            class="bc-primary text-white no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="nextStep()"
            :disabled="computedNextButton"
            >گام بعدی</v-btn
          >
        </v-col>
        <v-spacer v-if="stepNumber < 3"></v-spacer>
        <v-col class="text-left pe-0 ps-0" md="4" sm="6" cols="12">
          <v-btn
            class="b-primary bc-white c-primary no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="previousStep()"
            v-if="stepNumber > 1"
            >گام قبلی</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="goToDown" @click="goDown()">
      <v-icon>mdi-chevron-down</v-icon>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import screenShot from "../../../mixins/screenShot";
import Chart from "../../../components/charts/Chart.vue";
import YearModal from "@/components/YearModal";
//import { set } from "vue/types/umd";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
    YearModal,
  },
  mixins: [screenShot],
  data() {
    return {
      filter: "",
      vLoading: false,
      iran: [],
      isSelected: false,
      selectedStates: [],
      selectedStatesIds: [],
      selectedUniversity: [],
      total: false,
      total2: false,
      stepNumber: 1,
      university: [],
      noUniversity: false,
      universitiesCurrentPage: 1,
      universitiesTotalRows: "",
      universitiesPerPage: 16,
      timeType: "",
      selectYearDialog: false,
      selectTimeRangeDialog: false,
      selectedUniDialog: false,
      selectDayModal: false,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      year: moment(new Date()).format("jYYYY"),
      selectedYear: "",
      currentYear: moment(new Date()).format("jYYYY"),
      range: {
        fromYear: parseInt(moment(new Date()).format("jYYYY")) - 1,
        fromMonth: moment(new Date()).format("jMM"),
        fromDay: moment(new Date()).format("jDD"),
        toYear: moment(new Date()).format("jYYYY"),
        toMonth: moment(new Date()).format("jMM"),
        toDay: moment(new Date()).format("jDD"),
      },
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دانشگاه" },
        { key: "cats", label: "موضوعات تقسیم کار ملی دانشگاه" },
        { key: "uniRequests", label: "طرح‌های کلان" },
      ],
      excelFields: [
        { field: "name", label: "نام دانشگاه" },
        { field: "cats", label: "موضوعات تقسیم کار ملی دانشگاه" },
        { field: "uniRequests", label: "طرح‌های کلان" },
      ],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      currentPage2: 1,
      projectCurrentPage: 1,
      totalRows2: "",
      perPage2: 10,
      tableBusy: false,
      items1: [],
      items1Excel: [],
      selectedRange: {},
      fromNumberOfDay: null,
      toNumberOfDay: null,
      dateType: "",
      tab: null,
      barBusy: false,
      barLoaded: false,
      doughnutLoaded: false,
      deviceType: "",
      pageLoading: false,
      reactivity: true,
      allData: {},
      barTable: [],
      showYearFromModal: false,
      showYearToModal: false,
    };
  },
  methods: {
    getItemYear(value) {
      this.year = value;
      this.selectedYear = this.year;
      this.timeType = "year";
    },
    getShowModal(value) {
      this.showYearModal = value;
    },
    getYearFrom(value) {
      this.range.fromYear = value;
    },
    getYearFromModal(value) {
      this.showYearFromModal = value;
      this.getNumberOfDays("from");
    },
    getYearTo(value) {
      this.range.toYear = value;
    },
    getYearToModal(value) {
      this.showYearToModal = value;
      this.getNumberOfDays("to");
    },
    persianMonthName(month) {
      let monthName;
      monthName = this.monthsName[Number(month) - 1];
      return monthName;
    },
    getLogo(item) {
      if (this.university.filter((x) => x.id == item)) {
        return this.university.filter((x) => x.id == item)[0].url;
      } else return "";
    },
    goDown() {
      var container = document.querySelector("html");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    chooseState(item) {
      if (
        this.selectedStates.length &&
        this.selectedStates.includes(item.name)
      ) {
        let index;
        index = this.selectedStates.indexOf(item.name);
        this.selectedStates.splice(index, 1);
        this.selectedStatesIds.splice(index, 1);
      } else {
        this.selectedStates.push(item.name);
        this.selectedStatesIds.push(item.id);
      }

      if (this.selectedStates.length == this.iran.length) {
        this.total = true;
      } else {
        this.total = false;
      }
    },
    chooseUniversity(item) {
      if (
        this.selectedUniversity.length &&
        this.selectedUniversity.includes(item.id)
      ) {
        let index;
        index = this.selectedUniversity.indexOf(item.id);
        this.selectedUniversity.splice(index, 1);
      } else {
        this.selectedUniversity.push(item.id);
      }

      if (this.selectedUniversity.length == this.university.length) {
        this.total2 = true;
      } else {
        this.total2 = false;
      }
    },
    selectAll(type) {
      if (type == "state") {
        this.iran.forEach((x) => {
          if (!this.selectedStates.includes(x.name)) {
            this.selectedStates.push(x.name);
            this.selectedStatesIds.push(x.id);
          }
        });
        this.total = true;
      }
      if (type == "uni") {
        this.university.forEach((x) => {
          if (!this.selectedUniversity.includes(x.id)) {
            this.selectedUniversity.push(x.id);
          }
        });

        this.total2 = true;
      }
      this.goDown();
    },
    removeAll(type) {
      if (type == "state") {
        this.selectedStates = [];
        this.selectedStatesIds = [];
        this.total = false;
      }
      if (type == "uni") {
        this.selectedUniversity = [];

        this.total2 = false;
      }
    },
    clearItem(index) {
      this.selectedStates.splice(index, 1);
      this.selectedStatesIds.splice(index, 1);
      this.selectedUniversity = [];
      this.total2 = false;
      if (!this.selectedStates.length) {
        this.previousStep();
        return;
      }

      this.getUniversities();
    },
    nextStep() {
      this.filter = "";
      if (this.stepNumber == 1) {
        if (this.selectedStates.length) {
          ++this.stepNumber;
          this.total2 = false;
          this.selectedUniversity = [];
          this.getUniversities();
        } else {
          this.total2 = false;
          this.selectedUniversity = [];
          this.stepNumber = 2;
        }
      } else {
        ++this.stepNumber;
        if (this.stepNumber == 2) {
          this.total2 = false;
          this.selectedUniversity = [];
          this.getUniversities();
        }
        if (this.stepNumber == 3) {
          this.tab = 0;

          this.getReportInfo();
        }
      }
      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    previousStep() {
      this.filter = "";
      if (this.stepNumber == 3 && !this.selectedStates.length) {
        this.stepNumber = 1;
      } else {
        --this.stepNumber;
      }

      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },

    getStates() {
      this.pageLoading = true;
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    goToSelectRange() {
      this.selectTimeRangeDialog = true;
      this.getNumberOfDays("from");
      this.getNumberOfDays("to");
    },
    changeDate(type) {
      if (type == "year") {
        if (this.range.fromYear > this.range.toYear) {
          this.range.toYear = this.range.fromYear;
        }
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
        }
        if (
          this.range.fromYear == this.range.toYear &&
          this.range.fromMonth == this.range.toMonth
        ) {
          if (this.range.fromDay > this.range.toDay) {
            this.range.toDay = this.range.fromDay;
          }
        }
      }
      if (type == "month") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
      if (type == "day") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
    },
    getNumberOfDays(type) {
      if (type == "from") {
        if (1 <= parseInt(this.range.fromMonth) < 7) {
          this.fromNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.fromMonth) &&
          parseInt(this.range.fromMonth) != 12
        ) {
          this.fromNumberOfDay = 30;
        }
        if (parseInt(this.range.fromMonth) == 12) {
          let isLead = moment(
            this.range.fromYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.fromNumberOfDay = 30;
          } else this.fromNumberOfDay = 29;
        }

        if (parseInt(this.range.fromDay) > parseInt(this.fromNumberOfDay)) {
          this.range.fromDay = this.fromNumberOfDay;
        }
      } else {
        if (1 <= parseInt(this.range.toMonth) < 7) {
          this.toNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.toMonth) &&
          parseInt(this.range.toMonth) != 12
        ) {
          this.toNumberOfDay = 30;
        }
        if (parseInt(this.range.toMonth) == 12) {
          let isLead = moment(
            this.range.toYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.toNumberOfDay = 30;
          } else this.toNumberOfDay = 29;
        }

        if (parseInt(this.range.toDay) > parseInt(this.toNumberOfDay)) {
          this.range.toDay = this.toNumberOfDay;
        }
      }
    },
    goFirst() {
      this.universitiesCurrentPage = 1;
    },
    getUniversities() {
      this.pageLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/universities/getBystate",
          {
            states: this.selectedStatesIds,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.university = res.data;
          this.universitiesTotalRows = this.university.length;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getReportInfo() {
      this.pageLoading = true;
      this.barBusy = true;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/universities/uniRequestReport",
          {
            universityIds: this.selectedUniversity,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.items1 = res.data;
            this.items1Excel = this.items1.map((x) => {
              return {
                name: x.name,
                cats: x.cats
                  .map((x, index) => `${Number(index) + 1}. ${x}`)
                  .join(" , "),
                uniRequests: x.uniRequests
                  .map(
                    (x, index) =>
                      `${Number(index) + 1}. ${x.faSubject} (${x.status})`
                  )
                  .join(" , "),
              };
            });
            this.totalRows = this.items1.length;
            this.barBusy = false;
          }
        });
      setTimeout(() => {
        this.barLoaded = true;
        this.doughnutLoaded = true;
        this.pageLoading = false;
      }, 4000);
    },
  },
  computed: {
    computedStates() {
      if (this.filter) {
        let filtered;
        filtered = this.iran.filter((x) => x.name.includes(this.filter));
        return filtered;
      } else {
        return this.iran;
      }
    },
    computedUniversities() {
      let filtered;
      filtered = this.university.filter((x) => x.name.includes(this.filter));
      filtered = filtered.slice(
        16 * (this.universitiesCurrentPage - 1),
        16 * this.universitiesCurrentPage
      );
      return filtered;
    },
    computedNextButton() {
      if (this.stepNumber == 1) {
        if (!this.selectedStates.length) {
          return true;
        } else return false;
      }
      if (this.stepNumber == 2) {
        if (!this.selectedUniversity.length) {
          return true;
        } else return false;
      }
      if (this.stepNumber == 3) {
        if (!this.timeType) {
          return true;
        } else return false;
      }
    },
    computedCharts() {
      if (!this.allData.barChartHasData && !this.allData.pieChartHasData) {
        return true;
      } else return false;
    },
  },
  mounted() {
    if (window.screen.width < 500) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 500) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.getStates();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .edit-icon {
    path {
      stroke: #068d9d !important;
    }
    transform: translateY(-2px);
  }
  .v-card__title {
    border-radius: 10px 10px 0 0;
  }
  .day-box {
    width: 37px;
    height: 37px;
    text-align: center;
    border-radius: 50%;
    padding-top: 8px;
    color: #656a81;
    &:hover {
      background-color: #eeeeee;
    }
    &.selected {
      background-color: #e6e6e6;
      color: #068d9d;
      font-weight: bold;
    }
  }
  .small-logoBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.universities-page {
  min-height: 400px;
  padding: 15px;
}
</style>
